<template>
      <myhead>{{ $route.query.title || $route.meta.title}}</myhead>
      <div class="box">
            <div class="" v-for="item,index in list" :key="index">
                  <div  @click.stop="item.open_status = !item.open_status" class="flex between item BGon Cfff radius15">
                       <div >
                              <p>{{ item.name }}</p>
                              <p class="item_img width22" v-if="item.open_status"><img  src="@/assets/img/icon65-1.png" alt=""></p>
                              <p class="item_img width22"  v-else><img src="@/assets/img/icon66-1.png" alt=""></p>
                        </div>
                        <div>共回答{{ item.count }}次</div> 
                  </div>
                  <div class="detail" v-if="item.open_status">
                        <div class="flex between C000  radius15 C666" style="background-color:#e9e9e9;margin:0 15px;padding:15px" v-for="v,i in item.list" @click="goDetail(v.type,v.id)" :key="i">
                              <div>
                                    <p class="size18 bold C000 ellipsis_text" >{{ v.name }}</p>
                                    <p class="ellipsis_text">出题人:{{ v.questions_setter }}</p>
                              </div>
                              <div>
                                    <p style="text-align:end;color:#578264" v-if="v.status_name == '已通过'">{{ v.status_name }}</p>
                                    <p style="text-align:end;color:#f1946f" v-else>{{ v.status_name }}</p>
                                    <p >{{ v.add_time }}</p>
                              </div>
                        </div>
                  </div>
                  
            </div>
      </div>

</template>

<script>
import ajax from "@/utils/request.js";
export default {
   data(){
    return{
      list:[]
    }
   },
   created(){
      this.init()
   },
   methods:{
      init(){
            ajax.post("users/getanswer").then(res=>{
                  this.list = res.data
                  this.list.forEach(item=> {
                        item.open_status = false
                  })     
                  console.log(this.list);

            })
      },
      goDetail(type,id){
            this.$router.push({
                  path:'/answer/detail',
                  query:{
                        type,id
                  }
            })
      }
   }
}
</script>

<style lang="scss" scoped>
.item{
      margin: 15px 15px 0;
      padding: 15px;
}
.item_img{
      margin: 0 auto;
}
.ellipsis_text{
      width: 50vw;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
}
</style>